<template>
  <div class="modal" v-if="seen">
    <div class="renamefile" v-if="!loader">
      <span @click="closebox" class="closefile">
        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
          <path
            fill="#fff"
            d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
          />
        </svg>
      </span>
      <div class="header">
        <h3>Compressed files will be renamed to</h3>
      </div>
      <div class="rename-btn" v-if="!rename">
        <p>
          <strong>{{ name }}</strong>
        </p>
        <p class="action">
          <span class="btn-continue" @click="compress">Continue</span>
          <span class="btn-rename" @click="change_name">Rename</span>
        </p>
      </div>
      <div class="rename-btn" v-if="rename">
        <p>
          <span class="rename-title">
            <svg style="width: 14px; height: 14px" viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z"
              />
            </svg>
            <strong>Rename</strong>
          </span>
          <input type="text" v-model="new_name" placeholder="File Name" />
          <span class="error" v-if="error">*Required</span>
        </p>
        <p class="action">
          <span class="btn-rename" @click="continue_compression"
            >Continue compression</span
          >
        </p>
      </div>
    </div>
    <div v-if="loader">
      <div class="permanent" v-if="!done">
        <span
          >Compressing <strong>{{ str_text(name) }}</strong></span
        >
        <span><img src="@/assets/30.gif" /></span>
      </div>
      <div class="permanent compressed" v-if="done">
        <span
          >Compessing of <strong>{{ str_text(name) }}</strong> completed</span
        >
        <span class="close-btn" @click="closebox">Ok</span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.header h3 {
  font-size: 18px;
  font-weight: bold;
}
.modal .renamefile {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  width: 520px;
}
.modal .renamefile .rename-btn {
  display: block;
  padding: 0 0.9em;
  width: 100%;
  margin-top: 0.8em;
  text-align: left;
}
.modal .renamefile .rename-btn input {
  width: 70%;
}
.modal .renamefile .rename-btn .action {
  display: flex;
  justify-content: left;
}

.modal .renamefile .rename-btn .action .btn-continue {
  cursor: pointer;
  background-color: #fc6d6c;
  border-radius: 3px;
  border: none;
  color: #fff;
  font-size: 14px;
  margin-right: 0.8em;
  padding: 0.8em 1em;
}
.modal .rename-btn .rename-title {
  display: flex;
  align-items: center;
}
.modal .renamefile .rename-btn .action .btn-rename {
  cursor: pointer;
  background-color: #1e6abb;
  border-radius: 3px;
  border: none;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin-right: 0.8em;
  padding: 0.8em 1em;
}
</style>

<script>
import { mapMutations } from "vuex";
import { setTimeout } from "timers";
import cookies from "@/services/cookies";

export default {
  data() {
    return {
      name: "",
      seen: false,
      index: null,
      loader: true,
      found: false,
      done: false,
      src: "",
      rename: false,
      new_name: "",
      ids: [],
      error: false,
    };
  },
  methods: {
    ...mapMutations([
      "UPDATE_TOTAL_USED_SPACE",
      "SET_DIRECTORY_CHILDREN",
      "SET_CURRENT_DIRECTORY",
      "SET_PATH",
      "SORT_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "UPDATE_DIRECTORY_CHILDREN",
      "EMPTY_FILE_ACTION",
      "EMPTY_FILES_INDEX",
      "SET_FILE_ACTION",
      "SET_SELECT_ALL",
    ]),
    logincall() {
      this.$parent.logincall();
    },
    change_name() {
      this.rename = true;
      this.new_name = this.name;
    },
    str_text(str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5);
        let sSeg = str.substr(str.length - 7, 7);

        return fSeg + "...." + sSeg;
      }
      return str;
    },
    load() {
      let items = Object.values(this.$store.getters.GET_FILES_INDEX);
      this.name = this.$store.getters.DIRECTORY_CHILDREN[items[0]].dir;
      this.seen = true;
      this.loader = false;
    },
    continue_compression() {
      let that = this;
      this.loader = true;

      if (this.new_name == "") {
        this.error = true;
        return;
      }

      this.ids = Object.keys(this.$store.getters.GET_FILES_INDEX);

      let data = {
        token: cookies.getCookie("token"),
        ids: this.ids,
        name: this.new_name,
        rename: false,
      };

      this.$socket.emit("compress-files", data, function (data) {
        if (data.message === "completed") {
          that.done = true;
          that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
          that.SORT_DIRECTORY_CHILDREN();
          //let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
          //that.UPDATE_TOTAL_USED_SPACE(total_space_used)

          that.$store.getters.DIRECTORY_CHILDREN.map((file) => {
            file.is_checked = false;
          });

          that.EMPTY_FILE_ACTION();
          that.EMPTY_FILES_INDEX();
          that.SET_FILE_ACTION("");
          that.SET_SELECT_ALL(false);
        }

        if (data.message === "exist") {
          that.done = false;
          that.seen = false;
          that.fileExist(data.new_name, data.old_name, data.ids);
        }

        if (data.data === false) {
          that.done = false;
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    compress() {
      let that = this;
      this.loader = true;

      this.ids = Object.keys(this.$store.getters.GET_FILES_INDEX);

      let data = {
        token: cookies.getCookie("token"),
        ids: this.ids,
        name: this.name,
        rename: false,
      };

      this.$socket.emit("compress-files", data, function (data) {
        if (data.message === "completed") {
          that.done = true;
          that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
          that.SORT_DIRECTORY_CHILDREN();
          //let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
          //that.UPDATE_TOTAL_USED_SPACE(total_space_used)

          that.$store.getters.DIRECTORY_CHILDREN.map((file) => {
            file.is_checked = false;
          });

          that.EMPTY_FILE_ACTION();
          that.EMPTY_FILES_INDEX();
          that.SET_FILE_ACTION("");
          that.SET_SELECT_ALL(false);
        }

        if (data.message === "exist") {
          that.done = false;
          that.seen = false;
          that.fileExist(data.new_name, data.old_name, data.ids);
        }

        if (data.data === false) {
          that.done = false;
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    fileExist(new_name, old_name, ids) {
      this.$parent.group_compress_file_exist(new_name, old_name, ids);
    },
    closebox() {
      this.seen = false;
    },
  },
};
</script>
